<template>
		<div class="topbar">
			<div class="w1200 bc">
				<ul class="topbar-right fr">
					<li v-if="isLogin==true">
					<span>您好</span>
					</li>
					<li v-if="isLogin==true">
						<a class="co2" :href="userCenterUrl">{{account}}</a>
					</li>
					<li v-if="isLogin==true">
						<a class="co2" @click="logout()">[退出]</a>
					</li>
					
					<li style="height: 30px;width: 77px;" @mouseenter="shopCartShow()" @mouseleave="shopCartHide()">
						<a v-on:click="toShopCart">购物车</a>(<a style="color: #f60;">{{count}}</a>)
						
						<div id="shopCartInfo" class="top_shopcart" v-if="isShow">
							<div class="spacer"></div>
							<!--没选商品-->
							<div v-if="shoppingCartNum == 0" class="no-goods">
								<img src="../../static/images/settleup-nogoods.png" width="57" height="49">购物车中还没有商品，赶紧选购吧！
							</div>
							<!--已选商品-->
							<div v-if="shoppingCartNum > 0" class="mylist">
								<h4>最新加入的商品 </h4>
								<ul>
									<li class="li-2" v-for="(bo,index) in boList" v-bind:id="bo.goodsCode+'_cart_pro'" >
										<a class="fl spic" v-on:click="toDetail(bo.goodsCode)" ><img v-bind:src="bo.imgSmall" width="50" height="50"></a>
										<p class="name">
											<a  v-on:click="toDetail(bo.goodsCode)"><span name="goodsName">{{ bo.goodsName }}</span><span v-if="bo.specName!=''">【{{ bo.specName }}】</span></a> &nbsp;&nbsp;&nbsp;<span style="color: #f60;">数量：{{ bo.goodsNumber }}</span>
										</p>
										<p class="other"><span>￥{{ bo.unitPrice  }}</span><br>
											<a class="del"  v-on:click="deleteGoods(bo.id,bo.goodsCode,index)">删除</a>
										</p>
									</li>
								</ul>
								<div class="fbar"><span class="fl ml10">共{{ count }}件商品　共计<b>￥ {{ sumMoney }}</b></span>
									<a class="fr gobuy"  v-on:click="toShopCart">去购物车</a>
								</div>
							</div>
						</div>
					</li>
					<li>
						<a href="http://www.baomate.com/aboutus/index.htm">关于我们</a>
					</li>
					<li>
						<a :href="contactUrl"  target="_blank">联系客服</a>
					</li>
					<li>
						<a href="http://en.baomate.com"  target="_blank">English</a>
					</li>
					
				</ul>
				<ul class="topbar-left fl">
					<li>
						您好！欢迎来到相伴宝！
					</li>
					<!--<li>
						<a class="co1" :href="indexUrl">返回相伴宝</a>
					</li>-->
					<li v-if="isLogin==false">
						<a class="co2" :href="loginUrl">[登录]</a>
					</li>
					<li v-if="isLogin==false">
						<a class="co2" :href="registerUrl">[注册]</a>
					</li>
				</ul>
			</div>
		</div>
	
</template>

<script>
	import {getImgUrl,getCmsUrl,getIndexUrl,getUcUrl,getAboutUsUrl,sysContactUrl} from "../../static/js/emallUtils.js"
	import API from "../../static/api/api.js"
	export default {
		name: 'topbar',
		data() {
			return{
				isLogin:false,
				isShow:false,
				account:'',
				userCenterUrl:'',
				loginUrl:'',
				registerUrl:'',
				logoutUrl:'',
				aboutUsUrl:'',
				indexUrl:'',
				contactUrl:'',
				shoppingCartNum:0,
				boList:[],
				count:0,
				goodsImgs:[],
				sumMoney:0,
				sortParam:'',
				carIsShow:'',
			}
		},
		methods:{
			logout:function(){
				localStorage.clear();
				API.loginOut(function(ret){});
				window.location.href = this.logoutUrl;
			},
			clearCookie:function(){
				var keys=document.cookie.match(/[^ =;]+(?=\=)/g); 
				if (keys) { 
				for(var i = keys.length; i--;) 
					document.cookie=keys[i]+'=0;expires=' + new Date( 0).toUTCString() 
				} 
			},
			jumpTo:function(name){
		  		this.$router.push({ name:name});
		  },
		  	getCookie:function(name) {
		        var bikky = document.cookie;
		        //console.log("bikky=="+bikky);
		        var toBikky = decodeURIComponent(bikky);
		        bikky = toBikky;
		        //console.log("toBikky=="+toBikky);
		        name += "=";
		        var i = 0; 
		        while (i < bikky.length){
		          var offset = i + name.length;
		          if (bikky.substring(i, offset) == name){ 
		            var endstr = bikky.indexOf(";", offset); 
		            if (endstr == -1) endstr = bikky.length;
		              return unescape(bikky.substring(offset, endstr)); 
		          }
		          i = bikky.indexOf(" ", i) + 1; 
		          if (i == 0) break; 
		        }
		        return null; 
		   },
			shopCartShow:function(){
				this.isShow = true;
			},
			shopCartHide:function(){
				this.isShow = false;
			},
			getShoppingCartNum:function(shopCode){
        		var that=this;
        		API.getShoppingCartNum(function(ret){
        			if(ret.code == "success"){
        				that.shoppingCartNum = ret.data.shoppingCartNum;
        			}
        		})
        	},
        	getShoppingCartList:function(){
        		var that=this;
        		API.getShoppingCartList(function(ret){
					 if(ret.code == "success"){
					 	that.boList = ret.data.boList;
					 	var totalCount = 0;
					 	var bos = new Array();
					 	bos = ret.data.boList;
					 	var money = 0;
					 	for(var i =0; i<bos.length;i++){
					 		var imgSmall = bos[i].imgSmall;
			                    if(imgSmall.indexOf(";")!=-1){
			                    	imgSmall=imgSmall.split(";")[0];
			                    }
					 		bos[i].imgSmall = getImgUrl()+"/upload/show.htm?filePath="+imgSmall;
					 		bos[i].unitPrice = bos[i].unitPrice / 100;
					 		money = money + bos[i].unitPrice * bos[i].goodsNumber;
					 		totalCount = totalCount + bos[i].goodsNumber;
					 	}
					 	that.sumMoney = money;
					 	that.count = totalCount;
					 }
        		})
        	},
        	deleteGoods:function(id,goodsCode,index){
        		var that=this;
        		API.deleteGoods(id,goodsCode, function(ret){
        			if(parseResult(ret, null, false)) {
						//jQuery("#" + goodsCode + "_cart_pro").remove();
						that.boList.splice(index, 1);
						that.getShoppingCartNum();
					}
        		})
        	},
        	toDetail:function(goodsCode) {
				this.$router.push({ path: '/goodsDetails', query:{goodsCode:goodsCode}});
				window.location.reload();
			},
			toShopCart:function(){
				this.$router.push({path:'/shopCart'});
			}
		},
		mounted(){
			var that = this;
			var account = this.getCookie("r_userAgent_account");
			//console.log("account=="+account);
			if(account != undefined && account != null && account != ""){
				that.isLogin = true;
				that.account = account;
			}
			
			that.userCenterUrl = getUcUrl() + '/index/default.htm';
			that.loginUrl = getUcUrl() + '/login.htm';
//			that.registerUrl = getUcUrl() + '/custm/user/user_reg_add.htm';
			that.registerUrl = getUcUrl() + '/custm/user/user_reg_add.htm?formCode=MCHT_USER_FORM';
			that.logoutUrl = getUcUrl() + '/logout.htm';
			that.aboutUsUrl = getAboutUsUrl();
			that.indexUrl = getIndexUrl();
			that.contactUrl = sysContactUrl;
			this.getShoppingCartNum();
			this.getShoppingCartList();
		}
	}
</script>
<style>
.top_shopcart{
	/*position: absolute;*/
    /*left: auto;*/
    /*right: 20rem;*/
    /*top: 30px;*/
    z-index:777;
    width: 310px;
    border: 1px solid #cfcfcf;
    background-color: #fff;
    border-bottom: 3px solid #60575a;
    position: relative;
    top: 0px;
    left: -112px;
	}
.mylist h4,.head-nav .mycart .goods-list .mylist h4{ text-align:left; padding-left:10px; font-size:14px;}
.mylist ul li,.head-nav .mycart .goods-list .mylist ul li{ padding:0 10px; text-align:left;font-size:12px;}
.mylist ul li.li-1,.head-nav .mycart .goods-list .mylist ul li.li-1{ height:30px; line-height:30px; background:#f9f9f9;}
.mylist ul li.li-2,.head-nav .mycart .goods-list .mylist ul li.li-2{ padding:10px;line-height:20px; overflow:hidden;}
.mylist ul li.li-2 .name,.head-nav .mycart .goods-list .mylist ul li.li-2 .name{ width:140px; float:left; margin-left:10px; }
.mylist ul li.li-2 .del,.head-nav .mycart .goods-list .mylist ul li.li-2 .del{ float:right;}
.mylist .spic,.head-nav .mycart .goods-list .mylist .spic{ border:solid 1px #ddd; padding:3px;}
.mylist .fbar,.head-nav .mycart .goods-list .mylist .fbar{ height:40px; line-height:40px; background:#f9f9f9;overflow:hidden;}
.mylist .fbar .gobuy,.head-nav .mycart .goods-list .mylist .fbar .gobuy { display:inline-block; margin-right:10px; margin-top:5px;padding:5px 10px; height:20px; line-height:20px; border-radius:3px; color:#fff; background:#FF6600; }
</style>


// WEBPACK FOOTER //
// src/components/TopBar.vue?53eced62